var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 0.5H3.5C1.567 0.5 0 2.067 0 4V32C0 33.933 1.567 35.5 3.5 35.5H31.5C33.433 35.5 35 33.933 35 32V4C35 2.067 33.433 0.5 31.5 0.5Z",
    fill: "#0042DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4375 16.1831V14.1937C28.4375 13.7105 28.0457 13.3187 27.5625 13.3187H12.4855C12.0023 13.3187 11.6105 13.7105 11.6105 14.1937V16.1831C11.6105 16.6663 12.0023 17.0581 12.4855 17.0581H27.5625C28.0457 17.0581 28.4375 16.6663 28.4375 16.1831Z",
    fill: "#FF8E20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43216 17.058C9.46474 17.058 10.3018 16.221 10.3018 15.1884C10.3018 14.1558 9.46474 13.3187 8.43216 13.3187C7.39957 13.3187 6.5625 14.1558 6.5625 15.1884C6.5625 16.221 7.39957 17.058 8.43216 17.058Z",
    fill: "#FF8E20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 19.8028V21.7921C6.5625 22.2754 6.95425 22.6671 7.4375 22.6671H22.5145C22.9977 22.6671 23.3895 22.2754 23.3895 21.7921V19.8028C23.3895 19.3195 22.9977 18.9278 22.5145 18.9278H7.4375C6.95425 18.9278 6.5625 19.3195 6.5625 19.8028Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5669 18.9277C25.5343 18.9277 24.6973 19.7648 24.6973 20.7974C24.6973 21.83 25.5343 22.6671 26.5669 22.6671C27.5995 22.6671 28.4366 21.83 28.4366 20.7974C28.4366 19.7648 27.5995 18.9277 26.5669 18.9277Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d1e2e458ee70b5e299eff42216a1d082.svg";
export { ForwardRef as ReactComponent };